export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.327 6.725V.998H7.66v5.727l1.533-1.527.94.94-2.666 2.667c-.26.26-.68.26-.94 0L3.86 6.138l.94-.94 1.527 1.527zM11.667 11c.366 0 .666-.3.666-.667V7.666h1.334v2.667c0 1.107-.894 2-2 2H2.333c-1.106 0-2-.893-2-2l.027-2.64h1.333l-.026 2.64c0 .367.3.667.666.667h9.334z\"/>",
  "attrs": {
    "width": "14",
    "height": "13",
    "viewBox": "0 0 14 13",
    "fill": "#fff",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};